import { Platform } from '@/types/platform'
import { SelectionFilterField, SortFieldValue } from '../../types'

const getSearchInputKey = ({
  essence,
  platform,
  userId,
}: {
  essence: string
  platform: Platform
  userId: number
}) => `cbis-${platform}-${userId}:${essence}`

const getFiltersKey = ({
  essence,
  platform,
  userId,
}: {
  essence: string
  platform: Platform
  userId: number
}) => `cbf-${platform}-${userId}:${essence}`

const getSortKey = ({
  essence,
  platform,
  userId,
}: {
  essence: string
  platform: Platform
  userId: number
}) => `cbs-${platform}-${userId}:${essence}`

const setControlBarDataInStorage = ({
  searchInputValue,
  filtersFieldValue,
  sortFieldValue,
  essence,
  userId,
  platform,
}: {
  searchInputValue?: string
  filtersFieldValue?: SelectionFilterField[]
  sortFieldValue?: SortFieldValue
  essence: string
  platform: Platform
  userId: number
}) => {
  if (typeof searchInputValue === 'string') {
    localStorage.setItem(
      getSearchInputKey({
        essence,
        platform,
        userId,
      }),
      searchInputValue.trim()
    )
  }

  if (filtersFieldValue) {
    localStorage.setItem(
      getFiltersKey({
        essence,
        platform,
        userId,
      }),
      JSON.stringify(filtersFieldValue)
    )
  }

  if (sortFieldValue) {
    localStorage.setItem(
      getSortKey({
        essence,
        platform,
        userId,
      }),
      JSON.stringify(sortFieldValue)
    )
  }
}

const getControlBarDataFromStorage = <
  FV = SelectionFilterField[],
  SV = SortFieldValue
>({
  essence,
  platform,
  userId,
}: {
  essence: string
  platform: Platform
  userId: number
}) => {
  let filtersFieldValue: FV | undefined
  let sortFieldValue: SV | undefined

  const searchInputValue =
    localStorage.getItem(
      getSearchInputKey({
        essence,
        platform,
        userId,
      })
    ) || undefined

  try {
    const filtersFieldValueJSON = localStorage.getItem(
      getFiltersKey({
        essence,
        platform,
        userId,
      })
    )

    if (filtersFieldValueJSON) {
      filtersFieldValue = JSON.parse(filtersFieldValueJSON) as FV
    }
  } catch {
    filtersFieldValue = undefined
  }

  try {
    const sortFieldValueJSON = localStorage.getItem(
      getSortKey({
        essence,
        platform,
        userId,
      })
    )

    if (sortFieldValueJSON) {
      sortFieldValue = JSON.parse(sortFieldValueJSON) as SV
    }
  } catch {
    sortFieldValue = undefined
  }

  return {
    filtersFieldValue,
    sortFieldValue,
    searchInputValue,
  }
}

export { setControlBarDataInStorage, getControlBarDataFromStorage }
